import { HeroPiece } from "../common-tile.model";


export class StoredTileDefinition {
  header: HeroPiece;
  headerIcons: string[];
  heroRow: HeroPiece;
  footerRows: HeroPiece[][];

  constructor(
    headerText: HeroPiece,
    headerIcons: string[] = [],
    heroRow: HeroPiece,
    footerRows: HeroPiece[][]
  ) {
    this.header = headerText;
    this.heroRow = heroRow;
    this.footerRows = footerRows;
    this.headerIcons = headerIcons;
  }
}

